import { render, staticRenderFns } from "./VerificationBadges.vue?vue&type=template&id=a05c01b0&scoped=true"
import script from "./VerificationBadges.vue?vue&type=script&lang=js"
export * from "./VerificationBadges.vue?vue&type=script&lang=js"
import style0 from "./VerificationBadges.vue?vue&type=style&index=0&id=a05c01b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05c01b0",
  null
  
)

export default component.exports